import { Link } from 'react-router-dom';
import { BRAND } from '@/config/brand';
import { cn } from '@/lib/utils';

// Brand logo lockup. size: 'sm' | 'md' (default) | 'lg'.
const SIZE_MAP = {
  sm: 'h-12',
  md: 'h-[76px]',
  lg: 'h-28',
};

export const Logo = ({ size = 'md', className }) => (
  <Link to="/" className={cn('inline-flex items-center', className)} data-testid="navbar-logo" aria-label={`${BRAND.name} home`}>
    <img 
      src="/logo.png" 
      alt={BRAND.name} 
      className={cn('w-auto object-contain', SIZE_MAP[size])}
      style={{ imageRendering: 'auto' }}
    />
  </Link>
);
